import React from 'react';
import './ErrorBoundary.css';

interface ErrorBoundaryProps {
  children: React.ReactNode;
  title: string;
  message: string;
  resetLabel: string;
  onReset: () => void;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    console.error('Unhandled error caught by ErrorBoundary:', error, info.componentStack);
  }

  handleReset = (): void => {
    this.setState({ hasError: false });
    this.props.onReset();
  };

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <div className="error-boundary" role="alert">
          <h2 className="error-boundary-title">{this.props.title}</h2>
          <p className="error-boundary-message">{this.props.message}</p>
          <button className="error-boundary-reset" onClick={this.handleReset}>
            {this.props.resetLabel}
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
